import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "../Reveal";

const Manifesto = () => {
  const { t } = useLanguage();
  return (
    <section data-testid="manifesto-section" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
      <Reveal>
        <p className="overline-tag">{t.manifesto.overline}</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold md:text-5xl">{t.manifesto.title}</h2>
      </Reveal>
      <div className="mt-16 grid gap-x-12 gap-y-14 md:grid-cols-2">
        {t.manifesto.chapters.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.12}>
            <div data-testid={`manifesto-chapter-${c.num}`} className="group border-t border-white/10 pt-8 transition-colors duration-500 hover:border-gold/40">
              <span className="font-display text-5xl font-light text-zinc-700 transition-colors duration-500 group-hover:text-gold">{c.num}</span>
              <h3 className="mt-4 font-display text-xl font-bold md:text-2xl">{c.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-400 md:text-base">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};

export default Manifesto;
